@import "../../foundation/styles/codePalette.css";

/*
 * highlight.js token theme. Each class is mapped to the base16 slot whose
 * role fits it (standard base16 → hljs convention); see `codePalette.css`
 * for slot semantics and source-of-truth colors.
 *
 * Selectors are global (highlight.js's class scheme leaves no choice), so
 * this file MUST stay the only place writing rules for `.hljs-*`.
 */

.hljs {
  color: var(--code-base05);
  background: transparent;
}

.hljs-comment,
.hljs-quote {
  color: var(--code-base03);
  font-style: italic;
}

.hljs-tag,
.hljs-name,
.hljs-variable,
.hljs-deletion {
  color: var(--code-base08);
}

.hljs-number,
.hljs-symbol,
.hljs-bullet,
.hljs-meta,
.hljs-link {
  color: var(--code-base09);
}

.hljs-class .hljs-title,
.hljs-type,
.hljs-section,
.hljs-doctag {
  color: var(--code-base0a);
}

.hljs-string,
.hljs-template-tag,
.hljs-template-variable,
.hljs-addition {
  color: var(--code-base0b);
}

.hljs-regexp,
.hljs-attribute,
.hljs-params,
.hljs-operator {
  color: var(--code-base0c);
}

.hljs-title,
.hljs-title.function_,
.hljs-built_in {
  color: var(--code-base0d);
}

.hljs-keyword,
.hljs-literal,
.hljs-selector-tag,
.hljs-strong {
  color: var(--code-base0e);
  font-weight: 600;
}

.hljs-emphasis {
  font-style: italic;
}
